import React, {Component} from "react";

export class HalvingTable extends Component {
    static displayName = HalvingTable.name;

    render() {
        const HALVING_INTERVAL = 210000;
        let part1 = [{
            No: 0,
            Date: '2009-01-19',
            Height: 0,
            Reward: 50
        },
        {
            No: 1,
            Date: '2012-11-28',
            Height: HALVING_INTERVAL,
            Reward: 25
        },
        {
            No: 2,
            Date: '2016-07-09',
            Height: HALVING_INTERVAL * 2,
            Reward: 12.5
        },
        {
            No: 3,
            Date: '2020-05-11',
            Height: HALVING_INTERVAL * 3,
            Reward: 6.25
        },
        {
            No: 4,
            Date: '2024-04-20',
            Height: HALVING_INTERVAL * 4,
            Reward: 3.125
        }];

        let part2Start = {
            No: 4,
            Year: 2024,
            Height: HALVING_INTERVAL * 4,
            Reward: 3.125
        }

        let part2 = [];
        for (let i = part2Start.No + 1; i <= part2Start.No + 29; i++) {
            // bitcoin has 8 decimals
            var reward = part2Start.Reward / Math.pow(2, (i - part2Start.No));
            reward = Math.trunc(reward * Math.pow(10, 8)) / Math.pow(10, 8);
            var rew = reward.toFixed(8);
            while (rew.endsWith("0")) {
                rew = rew.replace(/0$/, '');
            }

            part2.push({
                No: i,
                Year: part2Start.Year + ((i - part2Start.No) * 4),
                Height: HALVING_INTERVAL * i,
                Reward: rew
            });
        }

        return (
            <div>
                <h4 className="text-center">
                    <i className="bi bi-bar-chart-steps" style={{ color: "brown" }}></i>{" "}
                Bitcoin Halving Schedules
                </h4>
                <ul>
                  <li>Bitcoin has a <strong>fixed monetary policy</strong> coded into its protocol.</li>
                    <li>Every <strong>210,000 blocks (approximately 4 years)</strong>, the block subsidy (new bitcoins issued per block) is <strong>cut in half</strong>.</li>
                    <li>This schedule continues until the maximum supply of <strong>21 million BTC</strong> is reached (around 2140).</li>
                </ul>
                <hr />
                <table className="table table-striped">
                    <thead className="thead-light">
                        <tr>
                        <th>Halving #</th>
                        <th>Halving Date</th>
                        <th>Block Height</th>
                        <th>Block Reward (BTC)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {part1.map((p) => (
                            <tr>
                                <td>{p.No}</td>
                                <td>{p.Date}</td>
                                <td>{p.Height}</td>
                                <td>{p.Reward}</td>
                            </tr>
                        ))}
                        {part2.map((p) => (
                            <tr>
                                <td>{p.No}</td>
                                <td>approx. {p.Year}</td>
                                <td>{p.Height}</td>
                                <td>{p.Reward}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}
